module.exports = __webpack_public_path__ + "static/cesta-von-d69bcfed4212688fdf59f838cc52beeb.png";